import request from '@/utils/request';

const path = 'tool/eventManager/optimizedGoalV2/jrtt';
/** 获取优化目标（体验版） */
export function getOptimizedGoalV2Api(data) {
  return request({
    url: `/${path}`,
    method: 'get',
    params: data,
  });
}
